@if (data) {
  <app-task-details (closeEventEmitter)="close()" [data]="data"></app-task-details>
}
